import { formatDisposition } from 'app/shared/utils/disposition';
import { FilterMoreDisplay } from 'app/modules/filters/components/FilterMoreDisplay';

import {
  FILTER_OPERATOR,
  FILTER_TYPE_OPERATOR_LABELS,
} from 'app/modules/filters/constants';

interface Props {
  value: string[];
}

export const DispositionFilterDisplay = (props: Props) => {
  const { value } = props;
  const formattedValues = value.map(formatDisposition);
  return (
    <>
      <b>Disposition</b>{' '}
      {FILTER_TYPE_OPERATOR_LABELS[FILTER_OPERATOR.IS_ONE_OF]}&nbsp;
      <FilterMoreDisplay values={formattedValues} />
    </>
  );
};
